module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "petForm",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "头像:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$config.upload_img_url,
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "accept": "image/*"
    }
  }, [(_vm.form.pet_avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$config.img_url + _vm.form.pet_avatar
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物类型:",
      "prop": "pet_type",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.petTypeChange
    },
    model: {
      value: (_vm.form.pet_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_type", $$v)
      },
      expression: "form.pet_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "dog"
    }
  }, [_vm._v("狗狗")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "cat"
    }
  }, [_vm._v("猫咪")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "other"
    }
  }, [_vm._v("其他")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物性别:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.pet_sex),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_sex", $$v)
      },
      expression: "form.pet_sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("公")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("母")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物昵称:",
      "prop": "pet_nickname",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宠物昵称",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.pet_nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_nickname", $$v)
      },
      expression: "form.pet_nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物品种:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择宠物品种"
    },
    model: {
      value: (_vm.form.pet_breed_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_breed_id", $$v)
      },
      expression: "form.pet_breed_id"
    }
  }, _vm._l((_vm.petsTypeList), function(type) {
    return _c('el-option', {
      key: type.pet_breed_id,
      attrs: {
        "label": type.pet_breed_name,
        "value": type.pet_breed_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物生日:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "请设置生日"
    },
    model: {
      value: (_vm.form.pet_birthday),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_birthday", $$v)
      },
      expression: "form.pet_birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "档案号:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入档案号",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.pet_file_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_file_number", $$v)
      },
      expression: "form.pet_file_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物毛色:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宠物毛色",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.pet_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_color", $$v)
      },
      expression: "form.pet_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物体重:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宠物体重",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.pet_weight),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_weight", $$v)
      },
      expression: "form.pet_weight"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("KG")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宠物身高:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宠物身高",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.pet_height),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_height", $$v)
      },
      expression: "form.pet_height"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("CM")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否绝育:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.pet_sterilization),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_sterilization", $$v)
      },
      expression: "form.pet_sterilization"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("已绝育")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("未绝育")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否疫苗:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.pet_vaccine),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_vaccine", $$v)
      },
      expression: "form.pet_vaccine"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("已疫苗")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("未疫苗")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.form.remake),
      callback: function($$v) {
        _vm.$set(_vm.form, "remake", $$v)
      },
      expression: "form.remake"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "FF7"
    },
    on: {
      "click": function($event) {
        return _vm.submitTap('2', 'petForm')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef8ca5de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/addPet.vue
// module id = 3511
// module chunks = 103